/*
 * @Author:
 * @LastEditTime: 2022-08-09 15:51:52
 * @Description: 高亮代码
 */
import Vue from 'vue'
import 'highlight.js/styles/a11y-light.css'
import highlight from 'highlight.js'

// v-highlight 高亮代码
Vue.directive('highlight', (el) => {
  highlight.configure({ ignoreUnescapedHTML: true })

  const blocks = el.querySelectorAll(' pre code')
  blocks.forEach((block) => {
    highlight.highlightElement(block)
  })
})
